export default {
  props: {
    type: String,
    text: String,
    btnone: Boolean
  },
  methods: {
    goBack() {
      console.log(this.type);
      if (this.type === "close") {
        this.$emit("close");
      } else {
        this.$router.go(-1);
      }
    }
  }
};